// Best Plate - Voting List
export const GET_BEST_PLATE_VOTING_PENDING = "GET_BEST_PLATE_VOTING_PENDING";
export const GET_BEST_PLATE_VOTING_FULFILLED =
  "GET_BEST_PLATE_VOTING_FULFILLED";
export const GET_BEST_PLATE_VOTING_REJECTED = "GET_BEST_PLATE_VOTING_REJECTED";

// Best Plate - Vote
export const SET_BEST_PLATE_VOTE_PENDING = "SET_BEST_PLATE_VOTE_PENDING";
export const SET_BEST_PLATE_VOTE_FULFILLED = "SET_BEST_PLATE_VOTE_FULFILLED";
export const SET_BEST_PLATE_VOTE_REJECTED = "SET_BEST_PLATE_VOTE_REJECTED";

// Best Plate - My Photos
export const GET_BEST_PLATE_MY_PHOTOS_PENDING =
  "GET_BEST_PLATE_MY_PHOTOS_PENDING";
export const GET_BEST_PLATE_MY_PHOTOS_FULFILLED =
  "GET_BEST_PLATE_MY_PHOTOS_FULFILLED";
export const GET_BEST_PLATE_MY_PHOTOS_REJECTED =
  "GET_BEST_PLATE_MY_PHOTOS_REJECTED";

// Best Plate - Upload
export const SET_BEST_PLATE_UPLOAD_PENDING = "SET_BEST_PLATE_UPLOAD_PENDING";
export const SET_BEST_PLATE_UPLOAD_FULFILLED =
  "SET_BEST_PLATE_UPLOAD_FULFILLED";
export const SET_BEST_PLATE_UPLOAD_REJECTED = "SET_BEST_PLATE_UPLOAD_REJECTED";

// Best Plate - Winners
export const GET_BEST_PLATE_WINNERS_PENDING = "GET_BEST_PLATE_WINNERS_PENDING";
export const GET_BEST_PLATE_WINNERS_FULFILLED =
  "GET_BEST_PLATE_WINNERS_FULFILLED";
export const GET_BEST_PLATE_WINNERS_REJECTED =
  "GET_BEST_PLATE_WINNERS_REJECTED";

// Best Plate - Status (yükleme kilidi + tema)
export const GET_BEST_PLATE_STATUS_PENDING = "GET_BEST_PLATE_STATUS_PENDING";
export const GET_BEST_PLATE_STATUS_FULFILLED =
  "GET_BEST_PLATE_STATUS_FULFILLED";
export const GET_BEST_PLATE_STATUS_REJECTED = "GET_BEST_PLATE_STATUS_REJECTED";
